var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.00056H3L6.29 1.71056C6.4783 1.52358 6.58462 1.26946 6.58556 1.0041C6.58649 0.738734 6.48198 0.483866 6.295 0.295562C6.10802 0.107259 5.8539 0.000943937 5.58854 6.25534e-06C5.32317 -0.000931427 5.0683 0.103585 4.88 0.290562L0.59 4.59056C0.214412 4.96391 0.00223279 5.47099 0 6.00056C0.00486659 6.52667 0.216844 7.02966 0.59 7.40056L4.88 11.7006C4.97324 11.7931 5.0838 11.8665 5.20537 11.9163C5.32694 11.9662 5.45714 11.9916 5.58854 11.9911C5.71993 11.9907 5.84995 11.9643 5.97116 11.9136C6.09238 11.8629 6.20242 11.7888 6.295 11.6956C6.38758 11.6023 6.46089 11.4918 6.51075 11.3702C6.5606 11.2486 6.58602 11.1184 6.58556 10.987C6.58509 10.8556 6.55875 10.7256 6.50804 10.6044C6.45733 10.4832 6.38324 10.3731 6.29 10.2806L3 7.00056H13C13.2652 7.00056 13.5196 6.89521 13.7071 6.70767C13.8946 6.52013 14 6.26578 14 6.00056C14 5.73535 13.8946 5.48099 13.7071 5.29346C13.5196 5.10592 13.2652 5.00056 13 5.00056Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDark);
export default __webpack_public_path__ + "static/media/arrow-left-dark.ff94359cef7f2fe31fb7b8f24ef6aec6.svg";
export { ForwardRef as ReactComponent };